import * as XLSX from 'xlsx'
import readBudget from './read-budget.js'

export default class PpFileReader {
  constructor () {
    console.log('FileReader constructor')

    this.workbook = null
  }

  async readFile (file) {
    console.log('FileReader readFile', file)

    /* get raw data */
    // https://docs.sheetjs.com/docs/demos/local/file/
    const data = await file.arrayBuffer()
    // data is an ArrayBuffer

    const workbook = XLSX.read(data)
    console.log('workbook', workbook)
    console.log('workbook.SheetNames', workbook.SheetNames) // sheetNames are available in workbook.SheetNames

    this.workbook = workbook

    return workbook
  }

  readBudget (sheetTarget) {
    console.log('readBudget', this.workbook, sheetTarget)
    return readBudget(this.workbook, sheetTarget)
  }
}
